/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useMetaData
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * metadata Hook
 * @returns {UseQueryResult} useMetaData
 */
const useServiceTypes = (options?: IQueryOptions): UseQueryResult<EligibilityRequestForm.IServiceType[]> => {
	return useQuery({
		queryKey: [QUERY_KEYS.serviceTypes],
		queryFn: async () => {
			const { data } = await api.ServiceTypesApi.getServiceTypes();
			return data;
		},
		refetchOnMount: false,
		refetchInterval: 1000 * 60 * 60 * 24, // 24 hours
		...(options || {}),
	});
};

export default useServiceTypes;
